import axios from "axios";

axios.defaults.headers.common.client = window.location.hostname.includes(
  "localhost"
)
  ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
  : `https://${window.location.hostname}`;

export default axios;
